export default {"src":"/_next/static/media/credit-card.b1cde803.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};